// eslint-disable-next-line import/prefer-default-export
export const DEFAULT_REVALIDATION_TIME = 60 * 10;
